import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chart, registerables } from 'chart.js'
import { BarChart, useBarChart } from 'vue-chart-3'
import { computed, PropType } from 'vue'
import { AdminStatisticType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  statistic: Array as PropType<AdminStatisticType[]>,
},
  setup(__props) {

const props = __props

Chart.register(...registerables)



const labels = computed(() =>
  props.statistic.map((statisticItem) => statisticItem.date)
)

const data = computed(() =>
  props.statistic.map((statisticItem) => statisticItem.count)
)

const datasets = computed(() => [
  {
    data: data.value,
    backgroundColor: '#d8d5ed',
  },
])

const chartData = computed(() => ({
  labels: labels.value,
  datasets: datasets.value,
}))

const plugins = {
  legend: {
    display: false,
  },
}

const scales = {
  x: {
    grid: {
      tickColor: 'transparent',
      drawOnChartArea: false,
    },
    ticks: {
      font: {
        size: 10,
      },
    },
  },
  y: {
    grid: {
      tickColor: 'transparent',
      drawBorder: false,
    },
    ticks: {
      stepSize: 1,
      font: {
        size: 12,
      },
    },
  },
}

const options = computed(() => ({
  indexAxis: 'x',
  maintainAspectRatio: false,
  plugins,
  scales,
  hoverBackgroundColor: '#73c707',
}))

const { barChartProps } = useBarChart({
  chartData: chartData.value,
  options,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BarChart), _mergeProps({ class: "user-statistic-chart" }, _unref(barChartProps)), null, 16))
}
}

})